import React from 'react';
import { InteractionInfo } from '$/components/Interactions/InteractionInfo';
import Form from '$/components/ui/Form';
import { readableColorOnBackground } from '$/utils/colors';
import { RatioOfPreviewCard } from '../Modals/variables';
import Textarea from '$/components/ui/Input/Basics/Textarea';
import { css } from '@emotion/react';
import tw from 'twin.macro';
import { staticWebinarDimensions } from '$/components/WebinarPlayer/context';
import { MediaRefFragment } from '$/GraphQL/schema/types';

export const NextWebinarModalTitle: React.FC<{
  interaction: InteractionInfo;
  imageMediaRef?: MediaRefFragment | null;
}> = ({ interaction, imageMediaRef }) => {
  const bgColor = interaction.ewebinar?.primaryColor ?? '#000';

  const rootRef = React.useCallback((node) => {
    if (!node) return;
  }, []);

  const titleRef = React.useCallback((node) => {
    if (node) {
      node.focus();
    }
  }, []);

  return (
    <div
      ref={rootRef}
      className='relative text-white leading-tight transition-all duration-200'
      css={css`
        background-size: cover;
        background-color: ${bgColor};
        .icard-title-row {
          width: 100%;
        }
        align-items: start;
        ${imageMediaRef ? `background-image: url(${imageMediaRef.imageUrl});` : ``}
        background-position: top center;
        padding-bottom: 0;
        padding-top: ${staticWebinarDimensions.actionsPane.icard.mediaTitleRatio * 100}%;
        font-size: calc(1rem * ${RatioOfPreviewCard});
        .icard-title-row {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          min-height: 3rem;
          background: rgba(0, 0, 0, 0.4);
          backdrop-filter: blur(2px);
          z-index: 10;
          .icard-title {
            margin: 0.6rem calc(1rem * ${RatioOfPreviewCard});
          }
          p {
            line-height: 1rem;
          }
        }
      `}
    >
      <div className='icard-title-area'>
        <div className='icard-title flex flex-col justify-between'>
          <div className='flex w-full'>
            <Form.Field
              name='details.title'
              className='title w-full mb-0 transition-colors duration-100 rounded-none'
              css={css`
                position: relative;
                textarea {
                  height: auto;
                  transition: background;
                  max-height: 52px;
                  padding: 0.25rem 0.75rem !important;
                  ${tw`duration-100 `}
                  resize: none;
                  color: ${imageMediaRef ? 'white' : readableColorOnBackground(bgColor)} !important;
                  background: rgba(0, 0, 0, 0.4) !important;
                  backdrop-filter: blur(2px);

                  &:focus {
                    color: ${imageMediaRef
                      ? 'white'
                      : readableColorOnBackground(bgColor)} !important;
                  }
                }
              `}
              component={
                <Textarea
                  id='interactionTitle'
                  css={css`
                    border-width: 2px;
                    border-style: dashed;
                    border-radius: 0;
                  `}
                  rows={1}
                  ref={titleRef}
                  autoGrow
                  enterBreakLine={false}
                  placeholder='Card title'
                />
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
